import { render, staticRenderFns } from "./compPropertyCard.vue?vue&type=template&id=65a8a428"
import script from "./compPropertyCard.vue?vue&type=script&lang=js"
export * from "./compPropertyCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports